import styles from './Footer.module.scss';

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <span>COPYRIGHT © 2022 KITHWARD ALL RIGHTS RESERVED</span>
    </div>
  );
};
